import React from "react";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import WebService from "api/explus-api";

// const Main = props => {
//     console.log("testestestest", props.children);
//     return (
//         <div className="site-main">
//             <Header bannerImage={props.bannerImage} />
//             <div className="container page">{props.children}</div>
//             <Footer />
//         </div>
//     );
// };

class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            childrenList: "",
            dswd: "", //2022
        };
    }

    getChildMenu() {
        // let items = null;
        const state = "childrenList";

        // if (sessionStorage.getItem(state)) {
        //     items = sessionStorage.getItem(state);

        //     // set cached data if it is available
        //     this.setState({ [state]: JSON.parse(items) });
        // } else {

        return WebService.ajaxGet("web/childrenmenu").then(data => {
            if (data.status === "error") {
                return;
            }

            this.setState({ [state]: data });

            // cache data in sessionStorage
            // items = sessionStorage.setItem(state, JSON.stringify(data));
        });

        // }
    }

    getPermits(){

        return WebService.getPermits("web/childrenmenu").then(data => {
            if (data.status === "error") {
                return;
            }

            if(data.dswd){
                this.setState({ ['dswd']: data.dswd });
            }
        });
    }

    componentDidMount() {
        this.getChildMenu();
        this.getPermits();
    }

    render() {
        return (
            <>
            <div className="site-main">
                <Header
                    bannerImage={this.props.bannerImage}
                    childrenList={this.state.childrenList}
                />
                <div className="container page">
                    {this.props.children}
                    </div>
                <Footer dswd={this.state.dswd} />
            </div>
            </>
        );
    }
}

export default Main;
